/** @module components/UploadMessage */
import React from "react";
import { Progress } from "./";
import { injectAndObserve } from "../store";
import { i18n, resolveIcon } from "../util";
import { Icon } from "react-aiot";
/**
 * Show the current uploading file with progress bar and status. It uses
 * the main store to read the current upload.
 *
 * @type React.Element
 */

export default injectAndObserve(({
  store,
  onCancel
}) => {
  const {
    currentUpload,
    uploadTotalRemainTime,
    readableUploadTotalLoaded,
    readableUploadTotalSize,
    readableUploadTotalBytesPerSec
  } = store;

  if (!currentUpload) {
    return null;
  }

  const {
    name,
    previewSrc,
    percent,
    readableLoaded,
    readableSize,
    deny,
    relativePathBasename,
    icon
  } = currentUpload,
        count = store.uploading.length;
  return /*#__PURE__*/React.createElement("span", {
    className: "rml-upload"
  }, /*#__PURE__*/React.createElement("div", {
    className: "rml-upload-trigger"
  }, !!previewSrc && /*#__PURE__*/React.createElement("div", {
    className: "rml-upload-image"
  }, /*#__PURE__*/React.createElement("img", {
    src: previewSrc
  })), /*#__PURE__*/React.createElement("div", {
    className: "rml-upload-container"
  }, /*#__PURE__*/React.createElement("strong", {
    className: "rml-upload-file"
  }, name), /*#__PURE__*/React.createElement("div", {
    className: "rml-upload-folder"
  }, resolveIcon(icon), " ", relativePathBasename), /*#__PURE__*/React.createElement(Progress, {
    percent: percent,
    size: "small",
    status: percent >= 100 ? "success" : "active"
  }), /*#__PURE__*/React.createElement("div", {
    className: "rml-upload-progress"
  }, count > 1 && /*#__PURE__*/React.createElement("span", null, i18n("filesRemaining", {
    count
  }), " \xB7\xA0"), percent >= 100 ? i18n("receiveData") : /*#__PURE__*/React.createElement("span", null, readableLoaded, " / ", readableSize), /*#__PURE__*/React.createElement("br", null), uploadTotalRemainTime, " \xB7 ", readableUploadTotalBytesPerSec, "/s\xA0", count > 1 ? /*#__PURE__*/React.createElement("span", null, "\xB7 ", readableUploadTotalLoaded, " / ", readableUploadTotalSize) : ""), !!deny && /*#__PURE__*/React.createElement("div", {
    className: "rml-upload-deny"
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "warning"
  }), " ", deny))), /*#__PURE__*/React.createElement("div", {
    className: "rml-upload-cancel",
    onClick: onCancel
  }, i18n("cancel")));
});